import { IReduxAction, actionGenerator } from '../../../common/utils/actions';

export const SET_MICROFRONTEND_INIT_LOAD_TIME = 'SET :: MICROFRONTEND :: INIT_LOAD_TIME';

export type TSetMicrofrontendInitLoadTimeAction = IReduxAction<typeof SET_MICROFRONTEND_INIT_LOAD_TIME, number>;

export const setMicrofrontendInitLoadTime = actionGenerator<typeof SET_MICROFRONTEND_INIT_LOAD_TIME, number>(
  SET_MICROFRONTEND_INIT_LOAD_TIME,
);
